module.exports = __webpack_public_path__ + "static/img/xun.af25ca0e.png";